var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Button, Heading } from "grommet";
import styled from "styled-components";
import { UserManager, Clock } from "grommet-icons";
var StyledHeading = styled(Heading)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose(["\n  &:hover {\n    color: #444444b0;\n  }\n"]))
);
export var Section = function Section(_ref) {
  var setSection = _ref.setSection,
    isMobileWidth = _ref.isMobileWidth,
    section = _ref.section,
    logout = _ref.logout;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Box,
      {
        style: {
          borderRadius: "10px",
          backgroundColor: "#F8F8F8",
        },
        gap: "0.8rem",
        pad: {
          vertical: "0.8rem",
          horizontal: "1rem",
        },
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          onClick: function onClick() {
            return setSection("UserSection");
          },
          flex: true,
          direction: "row",
          pad: {
            vertical: "0.5rem",
          },
          style: {
            cursor: "pointer",
            borderBottom: "1px solid black",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            style: {
              position: "relative",
            },
          },
          /*#__PURE__*/ React.createElement(UserManager, {
            color: section === "UserSection" ? "black" : "",
            style: {
              position: "absolute",
              bottom: "2px",
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            margin: {
              left: "2.3rem",
            },
          },
          /*#__PURE__*/ React.createElement(
            StyledHeading,
            {
              level: 6,
            },
            "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
          )
        )
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          onClick: function onClick() {
            return setSection("ActivitySection");
          },
          flex: true,
          direction: "row",
          pad: {
            vertical: "0.5rem",
          },
          style: {
            cursor: "pointer",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            style: {
              position: "relative",
            },
          },
          /*#__PURE__*/ React.createElement(Clock, {
            color: section === "ActivitySection" ? "black" : "",
            style: {
              position: "absolute",
              bottom: "2px",
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            margin: {
              left: "2.3rem",
            },
          },
          /*#__PURE__*/ React.createElement(
            StyledHeading,
            {
              level: 6,
            },
            "\u0410\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
          )
        )
      )
    ),
    isMobileWidth
      ? /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            align: "center",
            justify: "center",
            height: {
              max: "2.5rem",
            },
            margin: {
              top: "1rem",
            },
            pad: {
              vertical: "0.5rem",
            },
            width: "100%",
            style: {
              borderRadius: "5px",
              backgroundColor: "black",
              color: "#F8F8F8",
              position: "absolute",
              bottom: "0",
            },
            onClick: function onClick() {
              return logout();
            },
          },
          /*#__PURE__*/ React.createElement(
            Button,
            {
              width: "100%",
            },
            "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
          )
        )
      : /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            align: "center",
            height: {
              max: "2.5rem",
            },
            margin: {
              top: "1rem",
            },
            pad: {
              vertical: "0.5rem",
            },
            style: {
              borderRadius: "5px",
              backgroundColor: "black",
              color: "#F8F8F8",
            },
            onClick: function onClick() {
              return logout();
            },
          },
          /*#__PURE__*/ React.createElement(
            Button,
            {
              width: "100%",
            },
            "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043F\u0440\u043E\u0444\u0438\u043B\u044F"
          )
        )
  );
};
